import {
  DashboardIcon,
  AllLeadsIcon,
  LeadManagementIcon,
  BrandCombinationNavIcon,
  NotificationManagementIcon,
} from "../utils/svgIcons";

const navConfig = {
  items: [
    {
      name: "Dashboard",
      url: "/dashboard",
      icon: <DashboardIcon />,
      key: "DASHBOARD",
    },
    {
      name: "Lead Management",
      url: "/leads/all",
      icon: <LeadManagementIcon />,
      key: "LEADS",
      children: [
        {
          name: "All Leads",
          url: "/leads/all",
          icon: <AllLeadsIcon />,
          key: "ALL_LEADS",
        },
        {
          name: "OLA Leads",
          url: "/ola-leads",
          icon: <AllLeadsIcon />,
          key: "OLALEADS",
        },
        // {
        //   name: 'TVS Leads',
        //   url: '/tvsleads',
        //   icon: <AllLeadsIcon/>,
        //   key: 'TVSLEADS',
        // },
        {
          name: "TVS_Leads",
          url: "/tvs-leads",
          icon: <AllLeadsIcon />,
          key: "TVS_LEADS",
        },
        {
          name: "Revolt Leads",
          url: "/revolt-leads",
          icon: <AllLeadsIcon />,
          key: "REVOLT_LEADS",
        },
        {
          name: "DialShree Leads",
          url: "/dialshree-leads",
          icon: <AllLeadsIcon />,
          key: "DIALSHREE",
        },
        {
          name: "DialShree Inbound Call Leads",
          url: "/dialshree-inbound-call-leads",
          icon: <AllLeadsIcon />,
          key: "DIALSHREE",
        },
        {
          name: "Ampere Leads",
          url: "/ampere-leads/",
          icon: <AllLeadsIcon />,
          key: "AMPERE",
        },
        {
          name: "Simple Leads",
          url: "/simple-leads",
          icon: <AllLeadsIcon />,
          key: "SIMPLE_LEADS",
        },
        // {
        //   name: 'DialShree inbound Call Leads',
        //   url: '/dialshree-inbound-leads/list',
        //   icon: <AllLeadsIcon/>,
        //   key: 'DIALSHREE',
        // },
        // {
        //   name: 'VIDA Leads',
        //   url: '/vida-world-leads/list',
        //   icon: <AllLeadsIcon/>,
        //   key: 'VIDA_WORLD_LEADS',
        // },
        {
          name: "TP Leads",
          url: "/tp-leads",
          icon: <AllLeadsIcon />,
          key: "TP_LEADS",
        },
        {
          name: "Lead Verification",
          url: "/lead-verification",
          icon: <AllLeadsIcon />,
          key: "OLALEADS",
        },
        // {
        //   name: 'DS Leads',
        //   url: '/dealer-showroom-leads',
        //   icon: <AllLeadsIcon/>,
        //   key: 'DS_LEADS',
        // },
      ],
    },
    {
      name: "Profile",
      url: "/settings",
      icon: <AllLeadsIcon />,
      key: "PROTECTED",
    },
    {
      name: "Brand Combination",
      url: "/brand-combination",
      icon: <BrandCombinationNavIcon />,
      key: "BRANDCOMBINATION",
    },
    {
      name: "Lead Cost Management",
      url: "/generate-report",
      icon: <LeadManagementIcon />,
      key: "LEAD_COST_MANAGEMENT",
      children: [
        {
          name: "Generate Report",
          url: "/generate-report",
          icon: <AllLeadsIcon />,
          key: "GENERATE_REPORT",
        },
        {
          name: "Campaigns",
          url: "/campaigns",
          icon: <AllLeadsIcon />,
          key: "CAMPAIGNS",
        },
      ],
    },
    {
      name: "Lead Pacing",
      url: "/lead-pacing",
      icon: <AllLeadsIcon />,
      key: "LEAD_PACING",
      superAdminOnly: true,
    },
    {
      name: "Notifications",
      url: "/notifications",
      icon: <NotificationManagementIcon />,
      key: "NOTIFICATIONS",
    },
    // Add more items as needed
  ],
};

export default navConfig;
